import React, { Component } from 'react';
import './Fields.css';
import { Link } from 'react-router-dom';
import API from '../services/api';
import eye from '../static/vectors/eye.svg';
import eyeSlash from '../static/vectors/eye-slash.svg';
import AuthService from '../services/auth';
import Modal from 'react-modal';
import checkCircle from '../static/vectors/check-circle.svg';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization  from './withAuthorization';

class SettingsPassword extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        password: '',
        newPassword: '',
      },
      passswordVisible: false,
      newPasswordVisible: false,
      isModalOpen: false,
      modalMessage: '',
      canSubmit: false,
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    const { fields } = this.state;
    const { ucdUser, authUser } = this.props;
    (new API()).post(`/users/${ucdUser.id}/update-password`,fields, AuthService.getAuthCookie())
      .then(response => {
        if(response.success) {
          authUser.updatePassword(fields.newPassword)
            .then(() => {
              this.setState({
                isModalOpen: true,
                modalMessage: response.message,
                canSubmit: false,
              });
            });
        } else {
          this.setState({
            isModalOpen: true,
            modalMessage: response.message,
            canSubmit: false,
          });
        }
      });
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;

    fields[name] = e.target.value;

    this.setState({ fields, canSubmit: true });
  }

  togglePasswordField(field) {
    let newState = this.state;
    newState[`${field}Visible`] = !this.state[`${field}Visible`];
    this.setState(newState);
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }


  render() {
    const { title } = this.props;
    const { passwordVisible, newPasswordVisible, fields, isModalOpen, modalMessage, canSubmit } = this.state;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form>
          <div className="field-container text">
            <div className="field-title">Current password</div>
            <div className="row">
              <div className="col">
                <input
                  type={(passwordVisible)?'text':'password'}
                  id="password"
                  name="password"
                  placeholder="Your password"
                  value={fields.password}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
                <div className="icon">
                  <img
                    src={(passwordVisible?eye:eyeSlash)}
                    onClick={() => {this.togglePasswordField('password')}}
                    alt="Visibility"
                  />
                </div>
              </div>
            </div>
          </div><div className="field-container text">
            <div className="field-title">New password</div>
            <div className="row">
              <div className="col">
                <input
                  type={(newPasswordVisible)?'text':'password'}
                  id="newPassword"
                  name="newPassword"
                  placeholder="Confirm new password"
                  value={fields.newPassword}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
                <div className="icon">
                  <img
                    src={(newPasswordVisible?eye:eyeSlash)}
                    onClick={() => {this.togglePasswordField('newPassword')}}
                    alt="Visibility"
                  />
                </div>
              </div>
            </div>
          </div>
          <Link
            to="/settings"
            className="cancel"
          >
            cancel
          </Link>
          <button
            className="btn submit"
            disabled={!canSubmit}
            onClick={(e) => {this.handleSubmit(e)}}
          >
            Save profile
          </button>
          <Modal
            isOpen={isModalOpen}
            onRequestClose={() => {this.closeModal()}}
            contentLabel="Example Modal"
            style={{
              content: {
                top: '50%',
                bottom: 'auto',
                left: '50%',
                right: 'auto',
                transform: 'translate(-50%, -50%)',
              }
            }}
          >
            <div className="content text-center">
              <img src={checkCircle} alt="check" />
              <div className="message">{modalMessage}</div>
              <button onClick={() => {this.closeModal()}}> Close X</button>
            </div>
          </Modal>
        </form>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => {
  return({
    ...props,
    ucdUser: state.sessionState.ucdUser,
    authUser: state.sessionState.authUser,
  });};

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition), connect(mapStateToProps))(SettingsPassword);


// WEBPACK FOOTER //
// ./src/components/SettingsPassword.js